module.exports = __webpack_public_path__ + "static/banner-image-1-1-97cfce3da4513c0a332c81ee683236aa.jpg";